import { createStore, applyMiddleware, compose } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import reducers from "./reducers";
import rootSaga from "./sagas";
import { persistStore, persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { actionsToIgnore } from "./utils/ignorableActions";
import { setupSentryForRedux } from "../sentry";

const createHistory = require("history").createBrowserHistory;

export function setupRedux() {
  const history = createHistory();
  const sagaMiddleware = createSagaMiddleware();
  const routeMiddleware = routerMiddleware(history);
  const middlewares = [thunk, sagaMiddleware, routeMiddleware];

  const persistConfig = {
    key: "root",
    storage,
    whitelist: ["questionnaire"],
  };
  const persistedReducer = persistCombineReducers(persistConfig, {
    ...reducers,
    router: connectRouter(history),
  });

  const sentryReduxEnhancer = setupSentryForRedux(actionsToIgnore);

  const composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
      : compose;

  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer)
  );
  const persistor = persistStore(store);

  sagaMiddleware.run(rootSaga);

  return { store, persistor, history };
}
